module.exports = __webpack_public_path__ + "img/MM old.32dda71c.png";